(function () {
  var OPEN_CLASS = 'cart-sidebar-show';
  var DRAWER = '#halo-cart-sidebar';
  var WRAPPER = '#halo-cart-sidebar .previewCart-wrapper';
  var rendering = false;
  var cartCache = null;
  var redrawTimer = null;
  var ignoreMutationsUntil = 0;
  var addonState = {};
  var bundleState = new WeakMap();

  var PRODUCTS = {
    pistol: {
      key: 'pistol',
      match: 'leather pistol case',
      title: 'Leather Pistol Case',
      variants: [
        { id: 41311502499934, title: 'Brown', color: '#6f3f20' },
        { id: 41311502565470, title: 'Dark Brown', color: '#3a2317' },
        { id: 42316292980830, title: 'Khaki Canvas', color: '#b89a62' },
        { id: 42316282593374, title: 'Sand', color: '#d8bea0' },
        { id: 42316293177438, title: 'Grey Canvas', color: '#73777a' },
        { id: 41311502532702, title: 'Black', color: '#111111' },
        { id: 42872277499998, title: 'Aztec', color: '#9a572d' },
        { id: 42872277467230, title: 'Olive', color: '#5e6641' }
      ]
    },
    wallet: {
      key: 'wallet',
      match: 'front pocket wallet',
      title: 'Front Pocket Wallet',
      price: 2995,
      image: 'https://cdn.shopify.com/s/files/1/1245/6197/files/front-pocket-leather-wallet-rfid-clip-aztec.jpg?v=1753986676',
      variants: [
        { id: 41770505502814, title: 'Aztec', color: '#9a572d' },
        { id: 39879157416030, title: 'Brown', color: '#6f3f20' },
        { id: 39287942643806, title: 'Black', color: '#111111' },
        { id: 41770505535582, title: 'Dark Brown', color: '#3a2317' },
        { id: 41770505568350, title: 'Sand', color: '#d8bea0' }
      ]
    },
    moneyClip: {
      key: 'moneyClip',
      match: 'magnetic money clip',
      title: 'Magnetic Money Clip',
      price: 1295,
      image: 'https://cdn.shopify.com/s/files/1/1245/6197/files/magnetic-money-clip-wallet-leather-cash-sand.jpg?v=1753902252',
      variants: [
        { id: 41770508877918, title: 'Sand', color: '#d8bea0' },
        { id: 39288237916254, title: 'Black', color: '#111111' },
        { id: 39288237883486, title: 'Brown', color: '#6f3f20' }
      ]
    },
    smallRange: {
      key: 'smallRange',
      match: 'small range bag',
      title: 'Small Range Bag',
      price: 19595,
      sale: 16656,
      save: 2939,
      copy: '15% off with 2 pistol cases',
      image: 'https://cdn.shopify.com/s/files/1/1245/6197/files/smallrangebagucleather.jpg?v=1767892219',
      properties: { _uc_offer: 'small_range_bag_15_with_2_pistol_cases' },
      variants: [
        { id: 42316365103198, title: 'Khaki Canvas', color: '#b89a62', image: 'https://cdn.shopify.com/s/files/1/1245/6197/files/smallrangebagucleather.jpg?v=1767892219' },
        { id: 42316365070430, title: 'Grey Canvas', color: '#73777a', image: 'https://cdn.shopify.com/s/files/1/1245/6197/files/grey2gunrange.jpg?v=1767892219' }
      ]
    },
    rangeBag: {
      key: 'rangeBag',
      match: 'range bag',
      title: 'Full Range Bag',
      price: 27495,
      sale: 21996,
      save: 5499,
      copy: '20% off with 3 pistol cases',
      image: 'https://cdn.shopify.com/s/files/1/1245/6197/files/tactical-range-bag-gear-carry-tan.jpg?v=1755096928',
      properties: { _uc_offer: 'range_bag_20_with_3_pistol_cases' },
      variants: [
        { id: 41308488433758, title: 'Tan', color: '#c8a36d', image: 'https://cdn.shopify.com/s/files/1/1245/6197/files/tactical-range-bag-gear-carry-tan.jpg?v=1755096928' },
        { id: 41308488466526, title: 'Grey', color: '#73777a', image: 'https://cdn.shopify.com/s/files/1/1245/6197/files/tactical-range-bag-gear-carry-grey.jpg?v=1773850181' }
      ]
    }
  };

  var PRODUCT_LIST = [PRODUCTS.pistol, PRODUCTS.wallet, PRODUCTS.moneyClip, PRODUCTS.smallRange, PRODUCTS.rangeBag];
  var PISTOL_BY_COLOR = {
    brown: 41311502499934,
    'dark brown': 41311502565470,
    'khaki canvas': 42316292980830,
    sand: 42316282593374,
    'grey canvas': 42316293177438,
    black: 41311502532702,
    aztec: 42872277499998,
    olive: 42872277467230
  };

  function rootUrl() {
    var root = window.routes && window.routes.root ? window.routes.root : window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function lower(value) {
    return String(value || '').toLowerCase();
  }

  function html(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function money(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((Number(cents) || 0) / 100);
  }

  function normalizeText(value) {
    return lower(value).replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function colorToken(value) {
    var text = normalizeText(value);
    if (!text) return '';
    if (/\bdark\s*brown\b|\bdk\s*brown\b|\bdkbrown\b/.test(text)) return 'dark brown';
    if (/\bgrey\s*canvas\b|\bgray\s*canvas\b|\bgrey\b|\bgray\b/.test(text)) return 'grey canvas';
    if (/\bkhaki\s*canvas\b|\bkhaki\b/.test(text)) return 'khaki canvas';
    if (/\baztec\b/.test(text)) return 'aztec';
    if (/\bolive\b/.test(text)) return 'olive';
    if (/\bblack\b/.test(text)) return 'black';
    if (/\bsand\b/.test(text)) return 'sand';
    if (/\bbrown\b/.test(text)) return 'brown';
    if (/\btan\b/.test(text)) return 'tan';
    return '';
  }

  function directText(node) {
    var text = '';
    Array.prototype.forEach.call(node && node.childNodes ? node.childNodes : [], function (child) {
      if (child.nodeType === 3) text += ' ' + child.nodeValue;
    });
    return text;
  }

  function tokenFromElement(element) {
    if (!element || !element.getAttribute) return '';
    var attrs = ['data-color', 'data-color-name', 'data-value', 'data-option', 'data-option-value', 'data-title', 'data-name', 'data-variant-title', 'data-swatch', 'aria-label', 'title', 'alt', 'value', 'class'];
    for (var i = 0; i < attrs.length; i += 1) {
      var token = colorToken(element.getAttribute(attrs[i]));
      if (token) return token;
    }
    token = colorToken(directText(element));
    if (token) return token;
    return colorToken(element.textContent);
  }

  function tokenFromTarget(target, root) {
    var node = target;
    while (node && node !== root) {
      var token = tokenFromElement(node);
      if (token) return token;
      node = node.parentElement;
    }
    return '';
  }

  function fetchCart() {
    return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
  }

  function cartChange(key, quantity) {
    return fetch(rootUrl() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed.');
      return response.json();
    });
  }

  function cartAdd(items) {
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart add failed.');
      return response.json();
    });
  }

  function updateCounts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = cart.item_count || 0; });
    document.querySelectorAll('[data-cart-text]').forEach(function (node) { node.textContent = cart.item_count === 1 ? 'item' : 'items'; });
  }

  function openDrawer() {
    document.body.classList.add(OPEN_CLASS);
    var drawer = document.querySelector(DRAWER);
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    document.body.classList.remove(OPEN_CLASS);
    var drawer = document.querySelector(DRAWER);
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  function productForItem(item) {
    var text = lower([item.product_title, item.title].join(' '));
    for (var i = 0; i < PRODUCT_LIST.length; i += 1) {
      if (text.indexOf(PRODUCT_LIST[i].match) !== -1) return PRODUCT_LIST[i];
    }
    return null;
  }

  function variantById(product, id) {
    if (!product) return null;
    return product.variants.find(function (variant) { return Number(variant.id) === Number(id); });
  }

  function cartHas(cart, match) {
    return (cart.items || []).some(function (item) {
      return lower([item.product_title, item.title].join(' ')).indexOf(match) !== -1;
    });
  }

  function cartHasProduct(cart, key) {
    return (cart.items || []).some(function (item) {
      var product = productForItem(item);
      return product && product.key === key;
    });
  }

  function pistolQty(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return lower(item.product_title).indexOf('leather pistol case') !== -1 ? sum + item.quantity : sum;
    }, 0);
  }

  function addonsFor(cart) {
    var addons = [];
    var qty = pistolQty(cart);
    if (qty >= 3 && !cartHasProduct(cart, 'rangeBag')) addons.push(PRODUCTS.rangeBag);
    else if (qty >= 2 && !cartHasProduct(cart, 'smallRange')) addons.push(PRODUCTS.smallRange);
    if (addons.length < 2 && !cartHas(cart, 'front pocket wallet')) addons.push(PRODUCTS.wallet);
    if (addons.length < 2 && !cartHas(cart, 'magnetic money clip')) addons.push(PRODUCTS.moneyClip);
    return addons.slice(0, 2);
  }

  function renderSwatches(product, activeId, className) {
    return product.variants.map(function (variant) {
      return '<button type="button" class="' + className + (Number(variant.id) === Number(activeId) ? ' is-active' : '') + '" style="--swatch:' + variant.color + '" data-product-key="' + product.key + '" data-variant-id="' + variant.id + '" aria-label="' + html(variant.title) + '" title="' + html(variant.title) + '"></button>';
    }).join('');
  }

  function renderAddon(product) {
    var selectedId = addonState[product.key] || product.variants[0].id;
    var selected = variantById(product, selectedId) || product.variants[0];
    var price = product.sale || product.price;
    var compare = product.sale ? '<s>' + money(product.price) + '</s>' : '';
    var save = product.save ? '<span>Save ' + money(product.save) + '</span>' : '';
    return '<article class="uc-cart-addon" data-addon-key="' + product.key + '" data-variant-id="' + selected.id + '">' +
      '<img src="' + html(selected.image || product.image) + '" alt="' + html(product.title) + '" loading="lazy">' +
      '<div class="uc-cart-addon__main"><strong>' + html(product.title) + '</strong>' +
      (product.copy ? '<em>' + html(product.copy) + '</em>' : '') +
      '<div class="uc-cart-addon__price"><b>' + money(price) + '</b>' + compare + save + '</div>' +
      '<div class="uc-cart-addon__swatches">' + renderSwatches(product, selected.id, 'uc-cart-addon__swatch') + '<small>' + html(selected.title) + '</small></div></div>' +
      '<button type="button" class="uc-cart-addon__add" data-addon-add="' + product.key + '" aria-label="Add ' + html(product.title) + '">+</button></article>';
  }

  function renderLineVariantSelect(item, product) {
    if (!product || !product.variants || product.variants.length < 2) return '';
    var options = product.variants.map(function (variant) {
      return '<option value="' + variant.id + '"' + (Number(variant.id) === Number(item.variant_id) ? ' selected' : '') + '>' + html(variant.title) + '</option>';
    }).join('');
    return '<label class="uc-cart-line__select-wrap"><span>Color</span><select class="uc-cart-line__select" data-line-key="' + html(item.key) + '">' + options + '</select></label>';
  }

  function linePrice(item) {
    var finalPrice = item.final_line_price;
    if (finalPrice === undefined) finalPrice = item.line_price;
    if (finalPrice === undefined) finalPrice = item.final_price * item.quantity;
    var original = item.original_line_price;
    if (original === undefined) original = item.original_price * item.quantity;
    return {
      finalPrice: Number(finalPrice) || 0,
      original: Number(original) || 0
    };
  }

  function allocationAmount(allocation) {
    if (!allocation) return 0;
    if (allocation.amount !== undefined) return Number(allocation.amount) || 0;
    if (allocation.allocated_amount !== undefined) return Number(allocation.allocated_amount) || 0;
    if (allocation.total_allocated_amount !== undefined) return Number(allocation.total_allocated_amount) || 0;
    if (allocation.discounted_amount !== undefined) return Number(allocation.discounted_amount) || 0;
    return 0;
  }

  function allocationTotal(allocations) {
    return (allocations || []).reduce(function (sum, allocation) {
      return sum + allocationAmount(allocation);
    }, 0);
  }

  function itemDiscount(item) {
    var lineDiscount = Number(item.line_level_total_discount || 0);
    if (lineDiscount > 0) return lineDiscount;
    return allocationTotal(item.line_level_discount_allocations || item.discount_allocations || item.discounts);
  }

  function cartSavings(cart) {
    var lineSavings = (cart.items || []).reduce(function (sum, item) {
      return sum + itemDiscount(item);
    }, 0);
    var hasCartDiscounts = (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) ||
      (cart.discount_applications && cart.discount_applications.length);
    var cartReportedSavings = hasCartDiscounts ? Number(cart.total_discount || 0) : 0;
    return Math.max(lineSavings, cartReportedSavings, 0);
  }

  function renderItem(item) {
    var product = productForItem(item);
    var variant = variantById(product, item.variant_id);
    var displayVariant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var color = variant ? variant.color : swatchColor(displayVariant);
    var price = linePrice(item);
    var discount = itemDiscount(item);
    var compare = discount > 0 && price.original > price.finalPrice ? '<s>' + money(price.original) + '</s>' : '';
    var saving = discount > 0 ? '<small>Savings applied</small>' : '';
    var image = item.image || (variant && variant.image) || '';
    return '<article class="uc-cart-line" data-line-key="' + html(item.key) + '">' +
      '<a class="uc-cart-line__image" href="' + html(item.url || '#') + '"><img src="' + html(image) + '" alt="' + html(item.product_title) + '" loading="lazy"></a>' +
      '<div class="uc-cart-line__body"><div class="uc-cart-line__top"><a href="' + html(item.url || '#') + '">' + html(item.product_title) + '</a><button type="button" data-uc-remove="' + html(item.key) + '" aria-label="Remove">&times;</button></div>' +
      (displayVariant ? '<div class="uc-cart-line__variant"><span style="--swatch:' + color + '"></span>' + html(displayVariant) + '</div>' : '') +
      renderLineVariantSelect(item, product) +
      '<div class="uc-cart-line__bottom"><div class="uc-cart-line__qty"><button type="button" data-uc-qty="-1" data-line-key="' + html(item.key) + '">-</button><input type="number" min="0" value="' + item.quantity + '" data-uc-qty-input data-line-key="' + html(item.key) + '"><button type="button" data-uc-qty="1" data-line-key="' + html(item.key) + '">+</button></div>' +
      '<div class="uc-cart-line__price"><strong>' + money(price.finalPrice) + '</strong>' + compare + saving + '</div></div></div></article>';
  }

  function swatchColor(title) {
    var token = colorToken(title);
    if (token === 'dark brown') return '#3a2317';
    if (token === 'brown') return '#6f3f20';
    if (token === 'khaki canvas' || token === 'tan') return '#b89a62';
    if (token === 'sand') return '#d8bea0';
    if (token === 'grey canvas') return '#73777a';
    if (token === 'black') return '#111111';
    if (token === 'aztec') return '#9a572d';
    if (token === 'olive') return '#5e6641';
    return '#8a542e';
  }

  function renderNudge(cart) {
    var qty = pistolQty(cart);
    if (qty === 1) return '<div class="uc-cart-nudge">Add 1 more pistol case to unlock 15% off.</div>';
    if (qty === 2) return '<div class="uc-cart-nudge">Add 1 more pistol case to unlock 20% off.</div>';
    if (qty >= 3) return '<div class="uc-cart-nudge">20% pistol case savings unlocked.</div>';
    return '';
  }

  function renderSummary(cart) {
    var total = Number(cart.total_price || 0);
    var savings = cartSavings(cart);
    var subtotal = savings > 0 ? total + savings : total;
    var itemText = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';
    return '<footer class="uc-cart-footer"><div class="uc-cart-total-row"><span>Subtotal</span><strong>' + money(subtotal) + '</strong></div>' +
      (savings > 0 ? '<div class="uc-cart-total-row uc-cart-total-row--save"><span>Savings applied</span><strong>-' + money(savings) + '</strong></div>' : '') +
      '<div class="uc-cart-total-row uc-cart-total-row--today"><span>Today&apos;s total (' + itemText + ')</span><strong>' + money(total) + '</strong></div>' +
      '<button type="button" class="uc-cart-checkout" data-uc-checkout>Secure checkout</button>' +
      '<button type="button" class="uc-cart-continue" data-uc-cart-close>Continue shopping</button>' +
      '<div class="uc-cart-trust"><span>Ships next business day from Texas</span><span>30-day returns</span><span>365-day warranty</span></div></footer>';
  }

  function render(cart) {
    var wrapper = document.querySelector(WRAPPER);
    var drawer = document.querySelector(DRAWER);
    if (!wrapper || !drawer) return;
    rendering = true;
    cartCache = cart;
    updateCounts(cart);
    drawer.classList.add('uc-cart-redo');
    var title = drawer.querySelector('.halo-sidebar-header .title');
    if (title) title.textContent = 'Cart';
    var addons = addonsFor(cart);
    if (!cart.items || !cart.items.length) {
      wrapper.innerHTML = '<div class="uc-cart-empty"><strong>Your cart is empty</strong><button type="button" data-uc-cart-close>Continue shopping</button></div>';
      rendering = false;
      return;
    }
    wrapper.innerHTML = '<section class="uc-cart-shell">' +
      (addons.length ? '<div class="uc-cart-addons">' + addons.map(renderAddon).join('') + '</div>' : '') +
      renderNudge(cart) +
      '<div class="uc-cart-lines">' + cart.items.map(renderItem).join('') + '</div>' +
      renderSummary(cart) + '</section>';
    ignoreMutationsUntil = Date.now() + 250;
    rendering = false;
  }

  function refreshAndRender(open) {
    return fetchCart().then(function (cart) {
      render(cart);
      if (open) openDrawer();
      document.dispatchEvent(new CustomEvent('uc:cart:updated', { detail: cart }));
      return cart;
    });
  }

  function scheduleRender() {
    if (rendering) return;
    if (Date.now() < ignoreMutationsUntil) return;
    window.clearTimeout(redrawTimer);
    redrawTimer = window.setTimeout(function () { refreshAndRender(false).catch(function () {}); }, 80);
  }

  function findItem(key) {
    return cartCache && cartCache.items ? cartCache.items.find(function (item) { return item.key === key; }) : null;
  }

  function changeQuantity(key, nextQty) {
    return cartChange(key, Math.max(0, nextQty)).then(function () {
      return refreshAndRender(true);
    });
  }

  function replaceVariant(key, variantId) {
    var item = findItem(key);
    if (!item || Number(item.variant_id) === Number(variantId)) return Promise.resolve();
    return cartChange(item.key, 0).then(function () {
      return cartAdd([{ id: Number(variantId), quantity: item.quantity, properties: item.properties || {} }]);
    }).then(function () {
      return refreshAndRender(true);
    });
  }

  function setAddonVariant(button) {
    var product = PRODUCTS[button.dataset.productKey];
    var variant = variantById(product, button.dataset.variantId);
    var card = button.closest('.uc-cart-addon');
    if (!product || !variant || !card) return;
    addonState[product.key] = variant.id;
    card.dataset.variantId = variant.id;
    card.querySelector('img').src = variant.image || product.image;
    card.querySelector('small').textContent = variant.title;
    card.querySelectorAll('.uc-cart-addon__swatch').forEach(function (swatch) {
      swatch.classList.toggle('is-active', Number(swatch.dataset.variantId) === Number(variant.id));
    });
  }

  function addAddon(key) {
    var product = PRODUCTS[key];
    if (!product) return Promise.resolve();
    var id = addonState[key] || product.variants[0].id;
    return cartAdd([{ id: Number(id), quantity: 1, properties: product.properties || {} }]).then(function () {
      return refreshAndRender(true);
    });
  }

  function bundleData(root) {
    var existing = bundleState.get(root);
    if (existing) return existing;
    existing = { groups: new Map(), recent: [] };
    bundleState.set(root, existing);
    return existing;
  }

  function bundleGroup(target, root) {
    return target.closest('[data-option-position], [data-option-index], fieldset, .product-form__input, .selector-wrapper, .swatch, .uc-bc-clean-option, .uc-bc-clean-selector') || target.parentElement || root;
  }

  function rememberBundleChoice(event) {
    var root = event.target.closest && event.target.closest('[data-uc-bc-clean]');
    if (!root) return;
    var token = tokenFromTarget(event.target, root);
    if (!token) return;
    var data = bundleData(root);
    var group = bundleGroup(event.target, root);
    data.groups.set(group, token);
    data.recent = data.recent.filter(function (entry) { return entry.group !== group; });
    data.recent.push({ group: group, token: token });
    if (data.recent.length > 6) data.recent.shift();
  }

  function parseJson(root, name) {
    var node = root.querySelector('[data-uc-bc-json="' + name + '"]');
    if (!node) return null;
    try { return JSON.parse(node.textContent || 'null'); } catch (error) { return null; }
  }

  function flattenVariants(value) {
    var found = [];
    var seen = {};
    function walk(item) {
      if (!item) return;
      if (Array.isArray(item)) return item.forEach(walk);
      if (typeof item !== 'object') return;
      if (item.id && (item.available !== undefined || item.price !== undefined || item.option1 !== undefined || item.title !== undefined) && !seen[item.id]) {
        seen[item.id] = true;
        found.push(item);
      }
      Object.keys(item).forEach(function (key) {
        if (key !== 'image' && key !== 'featured_image') walk(item[key]);
      });
    }
    walk(value);
    return found.length ? found : PRODUCTS.pistol.variants;
  }

  function desiredBundleCount(root, button) {
    var card = button.closest('.uc-bc-clean-card') || root.querySelector('.uc-bc-clean-card.is-selected, .uc-bc-clean-card.is-active, .uc-bc-clean-card[aria-pressed="true"], .uc-bc-clean-card[aria-selected="true"]');
    var tier = card && card.getAttribute('data-uc-bc-tier');
    if (tier === 'single') return 1;
    if (tier === 'two') return 2;
    if (tier === 'more') return 3;
    var raw = lower((card && card.textContent) || button.textContent || '');
    if (raw.indexOf('three') !== -1 || raw.indexOf('3') !== -1) return 3;
    if (raw.indexOf('two') !== -1 || raw.indexOf('2') !== -1) return 2;
    return 1;
  }

  function selectedBundleTokens(root) {
    var tokens = [];
    var data = bundleData(root);
    data.groups.forEach(function (token) {
      if (token) tokens.push(token);
    });
    var selected = root.querySelectorAll('select, input:checked, label.is-selected, label.selected, label.active, label.is-active, button.is-selected, button.selected, button.active, button.is-active, [data-color].is-selected, [data-color].selected, [data-value].is-selected, [data-value].selected, [aria-pressed="true"], [aria-selected="true"]');
    selected.forEach(function (node) {
      if (node.tagName === 'SELECT' && node.selectedOptions) {
        Array.prototype.forEach.call(node.selectedOptions, function (option) {
          var token = tokenFromTarget(option, root);
          if (token) tokens.push(token);
        });
        return;
      }
      var token = tokenFromTarget(node, root);
      if (token) tokens.push(token);
      if (node.tagName === 'INPUT' && node.id) {
        var label = root.querySelector('label[for="' + node.id.replace(/"/g, '\\"') + '"]');
        token = tokenFromTarget(label, root);
        if (token) tokens.push(token);
      }
    });
    data.recent.forEach(function (entry) { if (entry.token) tokens.push(entry.token); });
    return tokens;
  }

  function bundleVariantIdFromToken(token, variants) {
    if (PISTOL_BY_COLOR[token]) return PISTOL_BY_COLOR[token];
    for (var i = 0; i < variants.length; i += 1) {
      var variant = variants[i];
      var match = colorToken([variant.title, variant.public_title, variant.option1, variant.option2, variant.option3].join(' '));
      if (match === token) return Number(variant.id);
    }
    return null;
  }

  function validVariantMap(variants) {
    var valid = {};
    variants.forEach(function (variant) { valid[String(variant.id)] = true; });
    return valid;
  }

  function variantIdFromField(node, valid) {
    if (!node) return null;
    var values = [];
    if (node.value !== undefined) values.push(node.value);
    ['data-variant-id', 'data-variant', 'data-id', 'data-uc-bc-variant-id', 'value'].forEach(function (attr) {
      if (node.getAttribute) values.push(node.getAttribute(attr));
    });
    if (node.tagName === 'SELECT' && node.selectedOptions) {
      Array.prototype.forEach.call(node.selectedOptions, function (option) {
        values.push(option.value);
        ['data-variant-id', 'data-variant', 'data-id', 'data-uc-bc-variant-id', 'value'].forEach(function (attr) {
          values.push(option.getAttribute && option.getAttribute(attr));
        });
      });
    }
    for (var i = 0; i < values.length; i += 1) {
      var match = values[i] && String(values[i]).match(/\d{8,}/);
      if (match && valid[match[0]]) return Number(match[0]);
    }
    return null;
  }

  function selectedVariantIdIn(container, variants, valid) {
    var fields = container.querySelectorAll('select[name="group_id"], input[name="group_id"], select[name="id"], input[name="id"]:checked, input[type="hidden"][name="id"]');
    for (var i = 0; i < fields.length; i += 1) {
      var id = variantIdFromField(fields[i], valid);
      if (id) return id;
    }
    var selected = container.querySelectorAll('select, input:checked, [data-variant-id].is-selected, [data-variant-id].selected, [data-variant-id].active, [data-variant-id].is-active, [data-variant].is-selected, [data-variant].selected, [data-id].is-selected, [data-id].selected, [aria-pressed="true"], [aria-selected="true"]');
    for (i = 0; i < selected.length; i += 1) {
      id = variantIdFromField(selected[i], valid);
      if (id) return id;
      var token = tokenFromTarget(selected[i], container);
      id = bundleVariantIdFromToken(token, variants);
      if (id) return id;
    }
    return null;
  }

  function selectedBundleVariantIds(root, variants, desired) {
    var valid = validVariantMap(variants);
    var ids = [];
    var slots = root.querySelectorAll('.bundle-product-item.isChecked, .uc-bc-clean-item.is-selected, .uc-bc-clean-item.is-active, [data-uc-bc-item].is-selected, [data-uc-bc-item].is-active');
    if (!slots.length) slots = root.querySelectorAll('.bundle-product-item, .uc-bc-clean-item, [data-uc-bc-item], [data-bundle-product-item-id]');
    slots.forEach(function (slot) {
      if (ids.length >= desired) return;
      var id = selectedVariantIdIn(slot, variants, valid);
      if (id) ids.push(id);
    });
    if (ids.length) return ids.slice(0, desired);
    root.querySelectorAll('select[name="group_id"], input[name="group_id"]').forEach(function (field) {
      if (ids.length >= desired) return;
      var id = variantIdFromField(field, valid);
      if (id) ids.push(id);
    });
    return ids.slice(0, desired);
  }

  function directVariantIds(root, variants) {
    var valid = validVariantMap(variants);
    var ids = [];
    var nodes = root.querySelectorAll('select, input:checked, input[type="hidden"], .is-selected, .selected, .active, .is-active, [aria-pressed="true"], [aria-selected="true"]');
    nodes.forEach(function (node) {
      var id = variantIdFromField(node, valid);
      if (id) ids.push(id);
    });
    return ids;
  }

  function bundleItems(root, button) {
    var variants = flattenVariants(parseJson(root, 'variants'));
    var desired = desiredBundleCount(root, button);
    var ids = selectedBundleVariantIds(root, variants, desired);
    selectedBundleTokens(root).forEach(function (token) {
      if (ids.length >= desired) return;
      var id = bundleVariantIdFromToken(token, variants);
      if (id) ids.push(id);
    });
    if (ids.length < desired) {
      directVariantIds(root, variants).forEach(function (id) {
        if (ids.length < desired) ids.push(id);
      });
    }
    if (ids.length < desired) return null;
    var qty = {};
    ids.slice(0, desired).forEach(function (id) { qty[id] = (qty[id] || 0) + 1; });
    return Object.keys(qty).map(function (id) { return { id: Number(id), quantity: qty[id] }; });
  }

  function handleBundleAdd(button, event) {
    var root = button.closest('[data-uc-bc-clean]');
    if (!root) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (button.dataset.busy === 'true') return;
    var items = bundleItems(root, button);
    if (!items || !items.length) {
      button.textContent = 'Pick colors first';
      window.setTimeout(function () { button.textContent = button.value || button.getAttribute('aria-label') || 'Add to cart'; }, 1100);
      return;
    }
    button.dataset.busy = 'true';
    var originalText = button.textContent;
    button.textContent = 'Adding...';
    cartAdd(items).then(function () {
      return refreshAndRender(true);
    }).then(function () {
      button.textContent = 'Added';
    }).catch(function (error) {
      console.error(error);
      button.textContent = 'Try again';
    }).finally(function () {
      window.setTimeout(function () {
        button.dataset.busy = 'false';
        button.textContent = originalText;
      }, 700);
    });
  }

  ['pointerdown', 'click', 'change'].forEach(function (eventName) {
    document.addEventListener(eventName, rememberBundleChoice, true);
  });

  document.addEventListener('click', function (event) {
    var bundleButton = event.target.closest && event.target.closest('.uc-bc-clean-add');
    if (bundleButton) return handleBundleAdd(bundleButton, event);

    var cartLink = event.target.closest && event.target.closest('a[href$="/cart"], a[href="/cart"]');
    if (cartLink && !cartLink.closest(DRAWER)) {
      event.preventDefault();
      refreshAndRender(true).catch(function () { openDrawer(); });
      return;
    }

    var close = event.target.closest && event.target.closest('[data-uc-cart-close], [data-close-cart-sidebar], .uc-cart-continue');
    if (close) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var checkout = event.target.closest && event.target.closest('[data-uc-checkout]');
    if (checkout) {
      event.preventDefault();
      window.location.href = rootUrl().replace(/\/$/, '') + '/checkout';
      return;
    }

    var addonSwatch = event.target.closest && event.target.closest('.uc-cart-addon__swatch');
    if (addonSwatch) {
      event.preventDefault();
      setAddonVariant(addonSwatch);
      return;
    }

    var addonAdd = event.target.closest && event.target.closest('[data-addon-add]');
    if (addonAdd) {
      event.preventDefault();
      addAddon(addonAdd.dataset.addonAdd).catch(function (error) { console.error(error); });
      return;
    }

    var qtyButton = event.target.closest && event.target.closest('[data-uc-qty]');
    if (qtyButton) {
      event.preventDefault();
      var item = findItem(qtyButton.dataset.lineKey);
      if (item) changeQuantity(item.key, item.quantity + Number(qtyButton.dataset.ucQty)).catch(function (error) { console.error(error); });
      return;
    }

    var remove = event.target.closest && event.target.closest('[data-uc-remove]');
    if (remove) {
      event.preventDefault();
      changeQuantity(remove.dataset.ucRemove, 0).catch(function (error) { console.error(error); });
      return;
    }

  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-uc-qty-input]');
    if (input) {
      var item = findItem(input.dataset.lineKey);
      if (!item) return;
      changeQuantity(item.key, Number(input.value || 0)).catch(function (error) { console.error(error); });
      return;
    }

    var select = event.target.closest && event.target.closest('.uc-cart-line__select');
    if (!select) return;
    replaceVariant(select.dataset.lineKey, select.value).catch(function (error) { console.error(error); });
  });

  document.addEventListener('cart-update', function () { scheduleRender(); });
  document.addEventListener('uc:cart:refresh', function () { refreshAndRender(false).catch(function () {}); });
  document.addEventListener('uc:cart:open', function () { refreshAndRender(true).catch(function () { openDrawer(); }); });

  window.refreshCartDrawer = function () { return refreshAndRender(false); };
  window.openCartDrawer = function () { return refreshAndRender(true); };
  window.openSliderCart = window.openCartDrawer;

  document.addEventListener('DOMContentLoaded', function () {
    refreshAndRender(false).catch(function () {});
    var wrapper = document.querySelector(WRAPPER);
    if (wrapper && window.MutationObserver) {
      new MutationObserver(function () { scheduleRender(); }).observe(wrapper, { childList: true });
    }
  });
})();
